import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../pagetitle/PageTitle'

export default function FuarYeri()
{
    const title = "OKAF Fuar Yeri - Samsun Üniversitesi";
    const description = "2024 yılı Orta Karadeniz Kariyer Fuarı (OKAF) fuar yeri.";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Fuar Yeri"></PageTitle>
            <div class="container">
                <div class="iletisimPage p-3 mb-3">
                    <div class="row main">
                        <div class="col-md-4 left mt-4">
                            <div class="colums">
                                <div class="icon"><i class="bi bi-geo-alt-fill"></i></div>
                                <div class="detail">
                                    <div class="head">Adres:</div>
                                    <div class="body">
                                        Cumhuriyet, Cumhuriyet 1 Sk. No:2, 55310 Tekkeköy/Samsun
                                    </div>
                                </div>
                            </div>
                            {/* <div class="colums">
                                <div class="icon"><i class="bi bi-telephone-fill"></i></div>
                                <div class="detail">
                                    <div class="head">Telefon:</div>
                                    <div class="body">0 (539) 349 39 55</div>
                                </div>
                            </div> */}
                        </div>
                        <div class="col-md-8 right">
                            <div class="map">
                                <div class="iframe">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000.644591118407!2d36.45052607643358!3d41.2295150057723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x408877bdaf8afa15%3A0xa4dc7811bfc3da92!2sT%C3%BCyap%20Samsun%20Fuar%20ve%20Kongre%20Merkezi!5e0!3m2!1str!2str!4v1703622902240!5m2!1str!2str" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
